// extracted by mini-css-extract-plugin
export default {"fileManagerContainer":"FileManager_fileManagerContainer__Fp-Lv","typeWrap":"FileManager_typeWrap__9i8dr"};